import { Link, useSearch } from "@tanstack/react-router";
import { Icon } from "../lib/Icon";
import { usePortal } from "./state";
import { articlesFor, categoryCounts, toCard } from "./reading";
import { ArticleCard, SectionHeader } from "./components";

export function PortalCategory() {
  const { brand, brandId, spaceId, user } = usePortal();
  const search = useSearch({ strict: false }) as { cat?: string };
  const cats = brand.cats;
  // Validate ?cat= against the brand's real categories — an arbitrary value must
  // not become an empty-state <h1>.
  const requested = search.cat;
  const activeCat = cats.some((c) => c[1] === requested) ? requested! : (cats[0]?.[1] ?? "");
  const counts = categoryCounts(brandId, spaceId);

  const arts = articlesFor(brandId, spaceId);
  const inCat = arts.filter((a) => a.cat === activeCat).map((a) => toCard(a, brand, "mark", user.org));

  return (
    <div style={{ maxWidth: 1040, margin: "0 auto", padding: "30px 28px 64px", display: "grid", gridTemplateColumns: "minmax(0, 220px) minmax(0, 1fr)", gap: 28, alignItems: "start" }}>
      {/* category rail */}
      <aside style={{ display: "flex", flexDirection: "column", gap: 2, position: "sticky", top: 0 }}>
        <div style={{ marginBottom: 8 }}><SectionHeader>Guides</SectionHeader></div>
        {cats.map(([icon, name]) => {
          const on = name === activeCat;
          return (
            <Link
              key={name}
              to="/portal/guides"
              search={{ cat: name }}
              style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: 10, padding: "9px 11px", borderRadius: 7, background: on ? brand.soft : "transparent", color: on ? brand.ink : "#4a504a", fontWeight: on ? 600 : 500, fontSize: 13.5 }}
            >
              <Icon name={icon} size={16} color={on ? brand.ink : "#8a8e88"} />
              <span style={{ flex: 1 }}>{name}</span>
              <span style={{ fontFamily: "'Space Mono', monospace", fontSize: 11, color: "#bcbfba" }}>{counts[name] ?? 0}</span>
            </Link>
          );
        })}
      </aside>

      {/* articles */}
      <div style={{ minWidth: 0 }}>
        <h1 style={{ margin: "0 0 4px", fontSize: 24, fontWeight: 600, letterSpacing: "-0.6px", color: "#1d241f" }}>{activeCat}</h1>
        <p style={{ margin: "0 0 18px", fontSize: 13.5, color: "#8a8e88" }}>{cats.find((c) => c[1] === activeCat)?.[2]}</p>
        {inCat.length === 0 ? (
          <div style={{ border: "1px dashed #dcdad2", background: "#fafaf7", borderRadius: 3, padding: "34px 20px", textAlign: "center", color: "#8a8e88", fontSize: 13.5 }}>
            Nothing in this category yet.
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {inCat.map((c) => (
              <ArticleCard key={c.id} card={c} brand={brand} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
